import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cloneRegion } from "../services/clone-region";

export function useCloneRegion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      sourceRegionId,
      targetRegionId,
      priceOverrides,
      productIds,
    }: {
      sourceRegionId: string;
      targetRegionId: string;
      priceOverrides?: Record<string, number>;
      productIds?: string[];
    }) =>
      cloneRegion(sourceRegionId, targetRegionId, priceOverrides, productIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
      queryClient.invalidateQueries({ queryKey: ["regions"] });
    },
  });
}
